// extracted by mini-css-extract-plugin
export default {"root":"DragPreview_root__-H2Xu","label":"DragPreview_label__Bf2WA"};